import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.0001 4.16797V15.8346M4.16675 10.0013H15.8334", stroke: "current", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgPlus;
